// Shared BUY/SELL/NEUTRAL palette used across FlowSight charts - was
// redefined per chart builder in both Conversions.vue and Overview.vue
// with the same hex values.
export const BUY_COLOR = '#27c1e6'
export const SELL_COLOR = '#ffb300'

// Bubble chart's "deselected" tone and heatmap's "outside tenor selection"
// tone are two DIFFERENT hex values today - kept as distinct exported
// constants rather than unified, to avoid a visual change.
export const NEUTRAL_COLOR = '#cfd8dc'
export const HEATMAP_NEUTRAL = '#e0e0e0'
export const HEATMAP_THRESHOLD = '#bdbdbd'
export const HEATMAP_NODATA = '#2b2b2b'
export const HEATMAP_ZERO = '#9e9e9e'
